import { Link } from 'react-router-dom'
import { FileText, Clock, Users, ExternalLink } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { useTranscripts } from '@/hooks/useTranscripts'
import { formatDateTime, formatDuration } from '@/lib/utils'

export function RecentTranscripts() {
  const { data, isLoading, error } = useTranscripts({ limit: 5 })

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Últimas Reuniões</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center h-32">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
          </div>
        </CardContent>
      </Card>
    )
  }

  if (error) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Últimas Reuniões</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-sm">Erro ao carregar reuniões</p>
        </CardContent>
      </Card>
    )
  }

  const transcripts = data?.data || []

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg">Últimas Reuniões</CardTitle>
        <Button variant="ghost" size="sm" asChild>
          <Link to="/transcripts">
            Ver todas
            <ExternalLink className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </CardHeader>
      <CardContent>
        {transcripts.length === 0 ? (
          <p className="text-muted-foreground text-sm text-center py-8">
            Nenhuma reunião encontrada
          </p>
        ) : (
          <div className="space-y-3">
            {transcripts.map((transcript) => (
              <Link
                key={transcript.id}
                to={`/transcripts/${transcript.id}`}
                className="flex items-center justify-between p-3 rounded-lg hover:bg-muted/50 transition-colors group"
              >
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-md bg-primary/10">
                    <FileText className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <p className="font-medium group-hover:text-primary transition-colors">
                      {transcript.room_name}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {formatDateTime(transcript.start_time)}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4 text-sm text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Clock className="h-4 w-4" />
                    {formatDuration(transcript.duration_seconds)}
                  </div>
                  <div className="flex items-center gap-1">
                    <Users className="h-4 w-4" />
                    {transcript.participants.length}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
